<template>
  <div>
    <bar-chart :chart-data="itemsData" :options="options"></bar-chart>
  </div>
</template>

<script>
import * as _ from "lodash";
export default {
  data() {
    return {
      // options: {
      //   scaleOverride: true,
      //   scaleStartValue: 0,
      //   scaleStepWidth: 1
      // },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      colors: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)"
      ],
      borderColors: [
        "rgba(255,99,132,1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)"
      ]
    };
  },

  props: {
    items: {
      type: Object,
      required: true
    }
  },

  computed: {
    itemsData: function() {
      var that = this;

      var formattedData = {
        labels: [],
        datasets: []
      };
      var colorIndex = 0;

      var dataset = {
        label: this.items.label,
        borderWidth: 1,
        data: [],
        backgroundColor: [],
        borderColor: []
      };

      _.forEach(this.items.collection, term => {
        dataset.backgroundColor.push(this.colors[colorIndex]);
        dataset.borderColor.push(this.borderColors[colorIndex]);
        dataset.data.push(term.total);
        if (!formattedData.labels.includes(term.term.description)) {
          formattedData.labels.push(term.term.description);
        }
      });

      formattedData.datasets.push(dataset);

      if (colorIndex < that.colors.length - 1) {
        colorIndex++;
      } else {
        colorIndex = 0;
      }

      return formattedData;
    }
  }
};
</script>

<style scoped>
</style>
